import React from 'react';

import PostBetWaitingContent from '../PostBetWaitingContent';

function LockedRoomContent({ responsiveMode, viewProps }) {
  return <PostBetWaitingContent responsiveMode={responsiveMode} viewProps={viewProps} />;
}

export default LockedRoomContent;
